import Professional from "../../models/Professional";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import TermsDeclarations from '../../models/TermsDeclarations'
import TermsDeclarationsService from "../../services/TermsDeclarationsService";


export default class TermsDeclarationsForm implements FormBase {

    MedicoParceiroDeclaration: FormFieldBase;

    constructor(MedicoParceiroDeclaration: boolean) {
        this.MedicoParceiroDeclaration = new FormFieldBase(new TermsDeclarations(0, MedicoParceiroDeclaration), [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustom(value) }));
    }

    ValidateFieldCustom(value: any): string {
        if (!value || !value.Checked) {
            return "É preciso aceitar os termos e declarações."
        } else {
            return "";
        }
    }

    static NewInstance(): TermsDeclarationsForm {
        return new TermsDeclarationsForm(false);
    }

    CallInsertOrUpdateApi(professional: Professional, customAttributes?: any): Promise<any> {
        const dataJson = this.getJsonObjet();
        return TermsDeclarationsService.postInsertOrUpdateTermsDeclarations(dataJson, professional.Id);
    }

    ValidateToGoNextStep(): string {

        let propNames = ["MedicoParceiroDeclaration"];

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, aceite os termos e declarações."
        } else {
            return "";
        }

    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {
            case "MedicoParceiroDeclaration":
                return this.MedicoParceiroDeclaration
            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet(professionalId: number = 0) {

        let viewModelList: any[] = [];
        viewModelList.push({ "textId": this.MedicoParceiroDeclaration.Value.TextId, "checked": this.MedicoParceiroDeclaration.Value.Checked })
        return viewModelList;
    }
}